import { Injectable, signal } from '@angular/core';

export type FlashType = 'success' | 'failure';

export interface FlashState {
  visible: boolean;
  type: FlashType | null;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class FlashService {
  readonly state = signal<FlashState>({
    visible: false,
    type: null,
    message: '',
  });

  private timeoutId?: ReturnType<typeof setTimeout>;

  show(type: FlashType, message: string, duration = 3000): void {
    clearTimeout(this.timeoutId);

    this.state.set({
      visible: true,
      type,
      message,
    });

    this.timeoutId = setTimeout(() => {
      this.hide();
    }, duration);
  }

  success(message: string, duration = 3000): void {
    this.show('success', message, duration);
  }

  failure(message: string, duration = 3000): void {
    this.show('failure', message, duration);
  }

  hide(): void {
    clearTimeout(this.timeoutId);

    this.state.update((state) => ({
      ...state,
      visible: false,
    }));
  }
}
